<header >
    <div class="logo-wrap" style="text-align: left;" >
        <img  src="assets/images/iLink-Digital.png">
    </div>
</header>
<body>
<div class="container">
	<div class="d-flex justify-content-center h-100">
		<div class="card">
			<div class="card-header text-center">
				<h3>Login to CSP Portal</h3>				
			</div>
			<div class="card-body">
				<form  [formGroup]="loginForm" (ngSubmit)="onSubmit()">
					<div class="input-group form-group">
					
                                                
                        <input type="text" formControlName="username" class="form-control" placeholder="Username" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                            <div *ngIf="f.username.errors.required">Username is required</div>
                        </div>
						
					</div>
					<div class="input-group form-group">
                        <input type="password" formControlName="password" class="form-control" placeholder="Password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.password.errors.required">Password is required</div>
                        </div>
					</div>
					
					<div class="form-group mx-auto mb-0 text-center">
                        
                        <button [disabled]="loading" class="btn login_btn">
                            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                            Login
                        </button>
                        <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
                        
					</div>
				</form>
			</div>
			
		</div>
	</div>
</div>
</body>